ACC.validation = {

  ckEmpty: /\S+/,
  currentLocale: '',
  countryDetails: '',
  countryDetailsResponse: '',
  registerPage: '.ph-page-register',
  registrationStateMain: '.ph-registration__state--main',
  formInput: '.ph-forminput',
  organisationCountry: '#organisationCountry',
  currentStoreId: '#currentStoreId',
  pcmsPhilipsUS: 'pcms-philips-us',
  singlestep: '.ph-page-singleStepCheckoutSummaryPage',
  cktpage: '.ph-page-AnonymousCheckoutPage',
  pmtpage: '.ph-page-AnonymousPaymentPage',

  alphanumeric: function(value) {
    var ckAlphanumeric = /^[A-Za-z0-9 ]{0,255}$/;

    if (ckAlphanumeric.test(value) || !ACC.validation.ckEmpty.test(value)) {
      return false;
    }

    return true;
  },

  alphanumericwithhyphen: function(value) {
    var ckAlphanumericwithhyphen = /^[A-Za-z0-9 -]{0,255}$/;

    if (ckAlphanumericwithhyphen.test(value) || !ACC.validation.ckEmpty.test(value)) {
      return false;
    }

    return true;
  },

  numeric: function(value) {
    var ckNumber = /^\d+$/;

    if (ckNumber.test(value) || !ACC.validation.ckEmpty.test(value)) {
      return false;
    }

    return true;
  },

  alpha: function(value) {
    var ckAlpha = /^[a-zA-Z ]+$/;

    if (ckAlpha.test(value) || !ACC.validation.ckEmpty.test(value)) {
      return false;
    }

    return true;
  },

  email: function(value) {
    /* eslint-disable  security/detect-unsafe-regex */
    var ckEmail = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,7}(?:\.[a-z]{2})?)$/i;

    /* To check if the configured email validation regex exist*/
    var emailValidationRegex = $('#emailValidationRegex').val();

    if (emailValidationRegex) {
      ckEmail = new RegExp(emailValidationRegex);
    }

    /* eslint-enable  security/detect-unsafe-regex */
    if (ckEmail.test(value)) {
      return false;
    }

    return true;
  },

  userName: function(value) {
    var ckUserName = /^[A-Za-z0-9 (.)_-]{0,255}$/;

    if (ckUserName.test(value) && ACC.validation.ckEmpty.test(value)) {
      return false;
    }

    return true;
  },

  poNumber: function(value) {
    /* eslint-disable  no-useless-escape */
    var ckUserName = /^[A-Za-z0-9 (.)/{}~`?/!@$^|\=+&_-]{0,255}$/;

    /* eslint-enable  no-useless-escape */
    if (ckUserName.test(value) || !ACC.validation.ckEmpty.test(value)) {
      return false;
    }

    return true;
  },

  postalPatternJson: function(selectedCountryCode) {
    // Note that json data already loaded on DOM ready.

    var regex = '';

    if (ACC.validation.countryDetailsResponse) {
      ACC.validation.countryDetailsResponse.some(function(countryDetail) {
        if (countryDetail.ISO === selectedCountryCode) {
          regex = countryDetail.Regex;

          return true;
        }

        return false;
      });
    }

    return regex;
  },

  postalPattern: function(existingLocale) {
    var ptrn = '',
        localeGroupOne = [
          'FR',
          'DE',
          'US',
          'SA'
        ],
        localeGroupTwo = [
          'SG',
          'IN'
        ],
        localeGroupThree = ['DX'];

    if (localeGroupOne.indexOf(existingLocale) > -1) {
      ptrn = '(^\\d{5}$)|(^\\d{5}-\\d{4}$)';
    } else if (localeGroupTwo.indexOf(existingLocale) > -1) {
      ptrn = '^\\d{6}$';
    } else if (localeGroupThree.indexOf(existingLocale) > -1) {
      ptrn = '(^\\d{5}$)|(^\\d{5}-\\d{4}$)|(^([A-Za-z0-9]{2,4})[ ][0-9A-Za-z]{3}$)|(^[1-9]\\d{5}$)|(^[1-9]\\d{3} ?(?!sa|sd|ss)[a-z]{2}$)|(^([A-Za-z0-9]{1,4})[ ][0-9A-Za-z]{1,4}$)';
    } else if (existingLocale === 'GB') {
      ptrn = '^([A-Za-z0-9]{2,4})[ ][0-9A-Za-z]{3}$';
    } else if (existingLocale === 'NL') {
      ptrn = '^[1-9]\\d{3}[ ](?!sa|sd|ss|SA|SD|SS|sA|sD|sS|Sa|Sd|Ss)[A-Za-z]{2}$';
    } else if (existingLocale === 'IT') {
      ptrn = '^\\d{5}$';
    } else if (existingLocale === 'AU') {
      ptrn = '^\\d{4}$';
    } else if (existingLocale === 'CA') {
      ptrn = '^[ABCEGHJ-NPRSTVXY]\\d[ABCEGHJ-NPRSTV-Z][ ]\\d[ABCEGHJ-NPRSTV-Z]\\d$';
    }

    return ptrn;
  },

  getStoreID: function() {
    var $postalValuetype = $('#postalValuetype');

    if ($postalValuetype.val() && $postalValuetype.val().split('-')[2]) {
      ACC.validation.currentLocale = $postalValuetype.val().split('-')[2].toUpperCase();
    } else if ($(ACC.validation.currentStoreId).val() && $(ACC.validation.currentStoreId).val().split('-')[2]) {
      ACC.validation.currentLocale = $(ACC.validation.currentStoreId).val().split('-')[2].toUpperCase();
    }

    if (ACC.validation.currentLocale === 'ONESTORE') {
      ACC.validation.currentLocale = 'US';
    }

    return ACC.validation.currentLocale;
  },

  /* eslint-disable complexity */
  countryCodeCheck: function(selectedIdValue) {
    var isOneStore = document.querySelector('.ph-isOneStore').innerText,
        countryCodeClass = '.ph-currentCountryCode',
        countryCodeVal = ACC.validation.currentLocale;

    var isNewValidation = document.querySelector('.ph-isNewValidation').innerText;

    if (selectedIdValue && document.querySelector(selectedIdValue) && document.querySelector(selectedIdValue).value) {
      countryCodeVal = document.querySelector(selectedIdValue).value;
    } else if (document.querySelector('#cboxLoadedContent .profileCountry') && document.querySelector('#cboxLoadedContent .profileCountry').innerText) {
      countryCodeVal = document.querySelector('#cboxLoadedContent .profileCountry').innerText;
    } else if (document.querySelector(countryCodeClass) && document.querySelector(countryCodeClass).innerText) {
      countryCodeVal = document.querySelector(countryCodeClass).innerText;
    }

    if (isOneStore && document.querySelector(countryCodeClass) && document.querySelector(countryCodeClass).innerText && isNewValidation !== 'true') {
      countryCodeVal = document.querySelector(countryCodeClass).innerText;
    }

    return countryCodeVal;
  },
  /* eslint-enable complexity */
  countryPostalCodeRegexCheck: function(countryCode) {
    var countryRegexVal = '';

    if (ACC.validation.currentLocale === countryCode) {
      countryRegexVal = ACC.validation.postalPattern(ACC.validation.currentLocale);
    } else {
      countryRegexVal = ACC.validation.postalPatternJson(countryCode);
    }

    return countryRegexVal;
  },
  stringToRegex: function(countryCode, countryRegex) {
    var countryRegexPattern = '';

    if (countryCode === 'CA') {
      countryRegexPattern = new RegExp(countryRegex, 'i');
    } else {
      countryRegexPattern = new RegExp(countryRegex);
    }

    return countryRegexPattern;
  },
  postalCodeCheckAvailableCountry: function(postalCodeValue, allowedCountryCodeList) {
    var isInvalid = true,
        countryRegexPattern = '',
        allowedCountryCodeArray = allowedCountryCodeList.split(',');

    if (allowedCountryCodeArray.length > 0) {
      allowedCountryCodeArray.forEach(function(countryCode) {
        var countryRegex = ACC.validation.countryPostalCodeRegexCheck(countryCode);

        if (countryRegex !== '') {
          countryRegexPattern = ACC.validation.stringToRegex(countryCode, countryRegex);
        }

        if (countryRegex && countryRegexPattern.test(postalCodeValue)) {
          isInvalid = false;
        }
      });
    }

    return isInvalid;
  },
  /* eslint-disable complexity */
  postalCode: function(postalCodeValue, selectedIdValue) {
    var countryCode = '',
        countryRegex = '',
        countryRegexPattern = '';

    ACC.validation.currentLocale = ACC.validation.getStoreID();

    countryCode = ACC.validation.countryCodeCheck(selectedIdValue);

    if (postalCodeValue && (ACC.validation.currentLocale === 'IE' || countryCode === 'IE')) {
      return false;
    }

    countryRegex = ACC.validation.countryPostalCodeRegexCheck(countryCode);

    if (countryRegex !== '') {
      countryRegexPattern = ACC.validation.stringToRegex(countryCode, countryRegex);
    }

    if ($(selectedIdValue).length === 0 && $('.ph-allowedCountryCodeList').text() !== '' && $('.ph-allowedCountryCodeList').length > 0) {
      var allowedCountryCodeList = $.trim($('.ph-allowedCountryCodeList').text());

      return ACC.validation.postalCodeCheckAvailableCountry(postalCodeValue, allowedCountryCodeList);
    } else if (countryRegex && countryRegexPattern.test(postalCodeValue)) {
      return false;
    } else if (ACC.validation.currentLocale === 'DX' && postalCodeValue.trim() !== '' && postalCodeValue.trim().length < 11) {
      return false;
    }

    return true;
  },
  /* eslint-enable complexity */
  validateAmount: function(value) {
    var ckUserName = /^[0-9(,.) ]{0,255}$/;

    if (ckUserName.test(value) || !ACC.validation.ckEmpty.test(value)) {
      return false;
    }

    return true;
  },

  phoneNumber: function(value) {
    var phoneRegexPattern = new RegExp('^[0-9 (),+-]{1,16}$');

    if (phoneRegexPattern.test(value)) {
      return false;
    }

    return true;
  },

  departmentCheck: function(value) {
    var department = /^[A-Za-z0-9 (./)&_-]{0,255}$/;

    if (department.test(value)) {
      return false;
    }

    return true;
  },

  currentStoreAccessed: function() {
    var storeVal = $(ACC.validation.currentStoreId).val();

    if (storeVal === 'pcms-philips-OneStore') {
      storeVal = ACC.validation.pcmsPhilipsUS;
    }

    return storeVal;
  },

  assignCurrentLocale: function(selectId) {
    if (document.querySelector(selectId).value) {
      document.querySelector(selectId).value = ACC.validation.currentLocale;
    }
  },

  preSelectCountry: function() {
    var storeValue = ACC.validation.currentStoreAccessed();

    if (storeValue === 'hhs-philips-us' || storeValue === 'hhs-philips-ca') {
      ACC.validation.assignCurrentLocale(ACC.validation.organisationCountry);
    } else if (storeValue === ACC.validation.pcmsPhilipsUS || storeValue === 'pcms-philips-sg' || storeValue === 'pcms-philips-au') {
      ACC.validation.assignCurrentLocale(ACC.validation.organisationCountry);
      ACC.validation.assignCurrentLocale('#billOrgCountry');
      ACC.validation.assignCurrentLocale('#shipOrgCountry');
      ACC.validation.assignCurrentLocale('#physicianCountry');
    } else {
      ACC.validation.assignCurrentLocale(ACC.validation.organisationCountry);
      ACC.validation.assignCurrentLocale('#billOrgCountry');
      ACC.validation.assignCurrentLocale('#shipOrgCountry');
    }
  },

  getRegionList: function(regionList, selectedCountrySiblingStateSelectId, countryRequestVal) {
    var selectedCountry = $('#' + selectedCountrySiblingStateSelectId).val();

    $('#' + selectedCountrySiblingStateSelectId).empty();

    if (countryRequestVal === 'false') {
      var pleaseSelectText = $('.ph-registerpage__pleaseselecttext').html();

      $('#' + selectedCountrySiblingStateSelectId).append('<option value="" disabled="disabled" selected="selected">' + pleaseSelectText + '</option>');
    }

    if (regionList) {
      $.each(regionList, function(singleStateIndex, singleStateData) {
        $('#' + selectedCountrySiblingStateSelectId).append('<option value="' + singleStateIndex + '">' + singleStateData + '</option>');
      });
    }

    if (countryRequestVal === 'true') {
      if (selectedCountry) {
        $('#' + selectedCountrySiblingStateSelectId).val(selectedCountry);
      }
    }

    $('#' + selectedCountrySiblingStateSelectId).selectBox('refresh');
  },

  onLoadPopulateRegions: function(regionList, countryRequestVal) {
    var storeValue = ACC.validation.currentStoreAccessed(),
        matchedLocaleOne = [],
        matchedLocaleTwo = [],
        matchedLocaleThree = [];

    if (countryRequestVal === 'true') {
      matchedLocaleOne = ['organisationCountry'];
      matchedLocaleTwo = [
        'organisationCountry',
        'billOrgCountry',
        'shipOrgCountry',
        'physicianCountry'
      ];
      matchedLocaleThree = [
        'organisationCountry',
        'billOrgCountry',
        'shipOrgCountry'
      ];
    } else {
      matchedLocaleOne = ['state'];
      matchedLocaleTwo = [
        'state',
        'billOrgState',
        'shipOrgState',
        'physicianState'
      ];
      matchedLocaleThree = [
        'state',
        'billOrgState',
        'shipOrgState'
      ];
    }

    if (storeValue === 'hhs-philips-us' || storeValue === 'hhs-philips-ca') {
      ACC.validation.getRegionList(regionList, matchedLocaleOne[0], countryRequestVal);
    } else if (storeValue === ACC.validation.pcmsPhilipsUS || storeValue === 'pcms-philips-sg' || storeValue === 'pcms-philips-au') {
      ACC.validation.getRegionList(regionList, matchedLocaleTwo[0], countryRequestVal);
      ACC.validation.getRegionList(regionList, matchedLocaleTwo[1], countryRequestVal);
      ACC.validation.getRegionList(regionList, matchedLocaleTwo[2], countryRequestVal);
      ACC.validation.getRegionList(regionList, matchedLocaleTwo[3], countryRequestVal);
    } else {
      ACC.validation.getRegionList(regionList, matchedLocaleThree[0], countryRequestVal);
      ACC.validation.getRegionList(regionList, matchedLocaleThree[1], countryRequestVal);
      ACC.validation.getRegionList(regionList, matchedLocaleThree[2], countryRequestVal);
    }
  },

  getStateListAjaxCall: function(selectedCountry, selectedCountrySiblingStateSelectId) {
    $.ajax({
      url: ACC.config.contextPath + '/register/getStates.json',
      type: 'GET',
      data: {
        selectedCountry: selectedCountry
      },
      async: false,
      cache: true,
      headers: {
        'Cache-Control': ACC.pdp.maxAgeValue
      },
      dataType: 'json',
      success: function(stateList) {
        if (selectedCountrySiblingStateSelectId) {
          ACC.validation.getRegionList(stateList, selectedCountrySiblingStateSelectId, 'true');
        } else {
          ACC.validation.onLoadPopulateRegions(stateList, 'false');
        }
      }
    });
  },

  stateListMain: function(countryId, populatedCountryFlag) {
    var selectedCountry = '',
        selectedcountryMainDiv = '',
        $selectedCountrySiblingStateMain = '',
        $selectedCountrySiblingStateSelectId = '',
        $currentPostalCodeWrrapper = '';

    if (populatedCountryFlag === 'false') {
      selectedCountry = $('#' + countryId).val();
      selectedcountryMainDiv = $('#' + countryId).parents('.ph-registration__country--main');
      $selectedCountrySiblingStateMain = selectedcountryMainDiv.siblings(ACC.validation.registrationStateMain);
      $selectedCountrySiblingStateSelectId = $selectedCountrySiblingStateMain.find('select').attr('id');
      $currentPostalCodeWrrapper = selectedcountryMainDiv.siblings('.ph-postalcode__wrapper');

      if ($currentPostalCodeWrrapper.find(ACC.validation.formInput).val() !== '') {
        $currentPostalCodeWrrapper.find(ACC.validation.formInput).trigger('blur');
      }
    } else {
      selectedCountry = countryId;
    }

    ACC.validation.getStateListAjaxCall(selectedCountry, $selectedCountrySiblingStateSelectId);
  },

  getCountryList: function(countryRequestVal) {
    $.ajax({
      url: ACC.config.contextPath + '/register/getCountries.json',
      type: 'GET',
      async: false,
      cache: true,
      headers: {
        'Cache-Control': ACC.pdp.maxAgeValue
      },
      dataType: 'json',
      success: function(countryList) {
        if (countryList) {
          ACC.validation.onLoadPopulateRegions(countryList, countryRequestVal);
        }
      }
    });
  },

  additionalShippingAddressPostalCheck: function() {
    var shippingAddresses = $('#shippingOrganization').find('select.ph-registration__country'),
        numberOfShippingAddresses = shippingAddresses.length;

    if (numberOfShippingAddresses > 0) {
      shippingAddresses.each(function() {
        if (!$(this).val()) {
          $(this).val(ACC.validation.getStoreID());
          $(this).selectBox('refresh');
        }
      });
    }
  }
};

$(document).ready(function() {
  if (document.querySelector('.ph-registerpage__countrydetails--json')) {
    ACC.validation.countryDetails = document.querySelector('.ph-registerpage__countrydetails--json').textContent;
    ACC.validation.countryDetailsResponse = JSON.parse(ACC.validation.countryDetails);
  }

  if ($(ACC.validation.registerPage).length > 0) {
    ACC.validation.currentLocale = ACC.validation.getStoreID();

    ACC.validation.getCountryList('true');
    ACC.validation.preSelectCountry();

    ACC.validation.stateListMain(ACC.validation.currentLocale, 'true');

    $(document).on('change', '.ph-registration__country.ph-formselect', function() {
      var changedCountryId = $(this).attr('id');

      $(this).selectBox('refresh');
      ACC.validation.stateListMain(changedCountryId, 'false');
    });
  }

  if ($(ACC.validation.currentStoreId).val() === 'pcms-philips-OneStore') {
    $(document).on('click', '#ph-buyingPreference ul.selectBox-options li', function() {
      ACC.registerpagebuttons.removeInfo(this);
    });
  }
});
